export default "__VITE_ASSET__lzQLXjBP__"